(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  /* ===========================
     DELIVERY DATE ENFORCEMENT (NO INTERVALS)
     - does NOT write Existing Shipment attribute (handled below)
     =========================== */
  (function () {
    const footer = document.getElementById('main-cart-footer');
    if (!footer || footer.classList.contains('is-empty')) return;

    const ATTRIBUTE_KEY_DATE = 'Delivery Date';
    const INPUT_SELECTOR_DATE = 'input[name="attributes[Delivery Date]"]';
    const WARNING_ID = 'delivery-date-warning';
    const TOGGLE_ID = 'existing-shipment-toggle';
    const warningEl = document.getElementById(WARNING_ID);

    function normalize(v) {
      return (v || '').replace(/\s+/g, ' ').trim();
    }

    function isValidDateValue(v) {
      const value = normalize(v);
      if (!value) return false;

      const lower = value.toLowerCase();
      if (
        lower.includes('mm') ||
        lower.includes('dd') ||
        lower.includes('yyyy') ||
        lower.includes('__') ||
        lower === 'na' ||
        lower === 'n/a'
      ) return false;

      if (value.length < 6) return false;
      const digits = (value.match(/\d/g) || []).length;
      if (digits < 4) return false;

      return true;
    }

    function bypassEnabled() {
      const t = document.getElementById(TOGGLE_ID);
      return !!(t && t.checked);
    }

    function isPickupSelected() {
      const pickupTab = document.querySelector('.otd_method.storePickupTab');
      const shipTab   = document.querySelector('.otd_method.shippingTab');

      if (pickupTab && shipTab) {
        const shipActive   = (shipTab.className || '').toLowerCase().includes('active_tab');
        const pickupActive = (pickupTab.className || '').toLowerCase().includes('active_tab');
        if (shipActive) return false;
        if (pickupActive) return true;
      }
      if (pickupTab) return (pickupTab.className || '').toLowerCase().includes('active_tab');
      return false;
    }

    function getCheckoutTargets() {
      const btns = Array.from(document.querySelectorAll('button[name="checkout"]'));
      const links = Array.from(document.querySelectorAll('a[href^="/checkout"]'));
      const dyn = Array.from(document.querySelectorAll('.shopify-payment-button__button,[data-testid="Checkout-button"]'));
      return Array.from(new Set([...btns, ...links, ...dyn]));
    }

    function setDeliveryWarning(show) {
      if (!warningEl) return;
      warningEl.style.display = show ? 'block' : 'none';
    }

    function setCheckoutEnabled(enabled) {
      getCheckoutTargets().forEach((el) => {
        if (!el) return;
        if (el.tagName === 'A') {
          el.style.pointerEvents = enabled ? '' : 'none';
          el.style.opacity = enabled ? '' : '0.6';
          el.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        } else {
          el.disabled = !enabled;
          el.style.pointerEvents = enabled ? '' : 'none';
          el.style.opacity = enabled ? '' : '0.6';
          el.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        }
      });
    }

    async function setCartAttributes(attrs) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: attrs }),
        });
      } catch (e) {}
    }

    function hardBlock(e) {
      if (!e) return false;
      if (typeof e.preventDefault === 'function') e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (warningEl && warningEl.scrollIntoView) {
        warningEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }

    function attachHardBlocks() {
      document.addEventListener('click', function (e) {
        const btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
        const dyn = e.target && e.target.closest ? e.target.closest('.shopify-payment-button__button,[data-testid="Checkout-button"]') : null;
        if ((btn || dyn) && !window.__delivery_ok) return hardBlock(e);
      }, true);

      document.addEventListener('click', function (e) {
        const a = e.target && e.target.closest ? e.target.closest('a[href^="/checkout"]') : null;
        if (a && !window.__delivery_ok) return hardBlock(e);
      }, true);

      document.addEventListener('submit', function (e) {
        const submitter = e.submitter;
        if (submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout') {
          if (!window.__delivery_ok) return hardBlock(e);
        }
      }, true);
    }

    let t = null;
    function scheduleRecheck() {
      clearTimeout(t);
      t = setTimeout(recheck, 120);
    }

    function recheck() {
      if (bypassEnabled() || isPickupSelected()) {
        window.__delivery_ok = true;
        setDeliveryWarning(false);

        const auctionBlocked = !!window.__auction_gate_blocked;
        setCheckoutEnabled(!auctionBlocked);
        return;
      }

      const input = document.querySelector(INPUT_SELECTOR_DATE);
      const dateOk = !!(input && isValidDateValue(input.value));

      setDeliveryWarning(!dateOk);
      window.__delivery_ok = dateOk;

      if (dateOk) setCartAttributes({ [ATTRIBUTE_KEY_DATE]: normalize(input.value) });

      const auctionBlocked = !!window.__auction_gate_blocked;
      setCheckoutEnabled(dateOk && !auctionBlocked);
    }

    function bindInputs() {
      const toggle = document.getElementById(TOGGLE_ID);
      if (toggle && !toggle.dataset.bound) {
        toggle.dataset.bound = '1';
        toggle.addEventListener('change', scheduleRecheck);
        toggle.addEventListener('click', scheduleRecheck);
      }

      const input = document.querySelector(INPUT_SELECTOR_DATE);
      if (input && !input.dataset.bound) {
        input.dataset.bound = '1';
        input.addEventListener('input', scheduleRecheck);
        input.addEventListener('change', scheduleRecheck);
        input.addEventListener('blur', scheduleRecheck);
      }
    }

    function init() {
      attachHardBlocks();
      bindInputs();

      const mo = new MutationObserver(() => bindInputs());
      mo.observe(document.documentElement, { childList: true, subtree: true });

      document.addEventListener('auctionGate:changed', scheduleRecheck);

      scheduleRecheck();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
